var loadMoreButton = document.getElementById('load-more-brochures');
var camps = document.getElementsByClassName('brochure-list--item');
var w = 4;
var x = 5;
var y = 6;
var z = 7;

if (loadMoreButton) {
    loadMoreButton.addEventListener('click', function(event) {
        event.preventDefault();
        newCount(w,x,y,z);
    
        w = w + 4;
        x = x + 4;
        y = y + 4;
        z = z + 4;
        
    })
}

function newCount(w,x,y,z) {

    for (var i = 0; i < camps.length; i++) {

        if (x + 1 > camps.length) {
            x = '';
        }
        if (w + 1 > camps.length) {
            w = '';
        }
        if (y + 1 > camps.length) {
            y = '';
        }
        if (z + 1 > camps.length) {
            z = '';
        }
    }

    updateClasses(w,x, y, z);
}

function updateClasses(w,x, y, z) {
    if (w !== '') {
        camps[w].classList.remove('brochure-list--item--disabled');
    } 
    if (x !== '') {
        camps[x].classList.remove('brochure-list--item--disabled');
    } 
    if (y !== '') {
        camps[y].classList.remove('brochure-list--item--disabled');
    } 
    if (z !== '') {
        camps[z].classList.remove('brochure-list--item--disabled');
    }

    if (x == '' || y == '' || z == '') {
        loadMoreButton.style.display = 'none';
    }
}